import React, { useState } from 'react';
import { LegalModal } from './LegalModal';
function PrivacyContent() {
  return <>
      <p className="text-gray-400 italic" data-id="element-45">Última actualización: Marzo 2026</p>

      <h3 className="text-white font-bold text-base mt-4" data-id="element-46">
        1. Información que Recopilamos
      </h3>
      <p data-id="element-47">
        Al adquirir nuestro Blueprint "Dinero Pro", recopilamos únicamente la
        información necesaria para procesar tu compra: nombre, dirección de
        correo electrónico y datos de pago. No almacenamos información de
        tarjetas de crédito en nuestros servidores.
      </p>

      <h3 className="text-white font-bold text-base mt-4" data-id="element-48">
        2. Uso de la Información
      </h3>
      <p data-id="element-49">Utilizamos tu información personal exclusivamente para:</p>
      <ul className="list-disc list-inside space-y-1 ml-2" data-id="element-50">
        <li data-id="element-51">Procesar y entregar tu compra del Blueprint.</li>
        <li data-id="element-52">
          Enviarte actualizaciones relacionadas con el producto adquirido.
        </li>
        <li data-id="element-53">Brindarte soporte al cliente si lo solicitas.</li>
      </ul>

      <h3 className="text-white font-bold text-base mt-4" data-id="element-54">
        3. Protección de Datos
      </h3>
      <p data-id="element-55">
        Implementamos medidas de seguridad estándar de la industria para
        proteger tu información personal. Utilizamos cifrado SSL para todas las
        transacciones y almacenamos los datos en servidores seguros.
      </p>

      <h3 className="text-white font-bold text-base mt-4" data-id="element-56">
        4. Compartir Información
      </h3>
      <p data-id="element-57">
        No vendemos, intercambiamos ni transferimos tu información personal a
        terceros. La única excepción son los proveedores de servicios de pago
        necesarios para procesar tu transacción.
      </p>

      <h3 className="text-white font-bold text-base mt-4" data-id="element-58">5. Cookies</h3>
      <p data-id="element-59">
        Nuestro sitio utiliza cookies esenciales para el funcionamiento del
        sitio y cookies analíticas para mejorar tu experiencia. Puedes
        desactivar las cookies en la configuración de tu navegador.
      </p>

      <h3 className="text-white font-bold text-base mt-4" data-id="element-60">
        6. Menores de Edad
      </h3>
      <p data-id="element-61">
        Nuestro producto está diseñado para adolescentes, pero las compras deben
        ser realizadas por un padre o tutor legal mayor de 18 años. No
        recopilamos intencionalmente información de menores de 13 años.
      </p>

      <h3 className="text-white font-bold text-base mt-4" data-id="element-62">7. Tus Derechos</h3>
      <p data-id="element-63">
        Tienes derecho a acceder, rectificar o eliminar tu información personal
        en cualquier momento. Para ejercer estos derechos, envíanos un correo
        electrónico.
      </p>
    </>;
}
function TermsContent() {
  return <>
      <p className="text-gray-400 italic" data-id="element-64">Última actualización: Marzo 2026</p>

      <h3 className="text-white font-bold text-base mt-4" data-id="element-65">
        1. Aceptación de los Términos
      </h3>
      <p data-id="element-66">
        Al acceder y comprar el Blueprint "Dinero Pro", aceptas estos términos y
        condiciones en su totalidad. Si no estás de acuerdo con alguna parte, no
        debes utilizar este sitio ni adquirir el producto.
      </p>

      <h3 className="text-white font-bold text-base mt-4" data-id="element-67">
        2. Descripción del Producto
      </h3>
      <p data-id="element-68">
        "Dinero Pro" es un producto digital educativo (Blueprint/guía) sobre
        educación financiera básica. No constituye asesoramiento financiero
        profesional, legal ni fiscal. El contenido es únicamente con fines
        educativos e informativos.
      </p>

      <h3 className="text-white font-bold text-base mt-4" data-id="element-69">
        3. Uso del Producto
      </h3>
      <p data-id="element-70">
        Al adquirir el Blueprint, recibes una licencia personal e intransferible
        para uso individual. Queda prohibido:
      </p>
      <ul className="list-disc list-inside space-y-1 ml-2" data-id="element-71">
        <li data-id="element-72">Reproducir, distribuir o revender el contenido.</li>
        <li data-id="element-73">Compartir el acceso con terceros.</li>
        <li data-id="element-74">Utilizar el contenido con fines comerciales sin autorización.</li>
      </ul>

      <h3 className="text-white font-bold text-base mt-4" data-id="element-75">
        4. Política de Reembolso
      </h3>
      <p data-id="element-76">
        Ofrecemos una garantía de devolución del 100% del dinero dentro de los
        primeros 7 días posteriores a la compra. Para solicitar un reembolso,
        debes contactarnos por correo electrónico dentro de dicho plazo.
      </p>

      <h3 className="text-white font-bold text-base mt-4" data-id="element-77">
        5. Descargo de Responsabilidad
      </h3>
      <p data-id="element-78">
        Los resultados mencionados en testimonios y ejemplos son ilustrativos y
        no garantizan resultados específicos. El éxito financiero depende de
        múltiples factores individuales. No somos responsables de decisiones
        financieras tomadas basándose en el contenido del Blueprint.
      </p>

      <h3 className="text-white font-bold text-base mt-4" data-id="element-79">
        6. Menores de Edad
      </h3>
      <p data-id="element-80">
        Las compras deben ser realizadas por personas mayores de 18 años. Si
        eres menor de edad, un padre o tutor legal debe realizar la compra en tu
        nombre. Cualquier actividad de inversión mencionada en el Blueprint
        requiere supervisión parental y cuentas custodia.
      </p>

      <h3 className="text-white font-bold text-base mt-4" data-id="element-81">
        7. Propiedad Intelectual
      </h3>
      <p data-id="element-82">
        Todo el contenido del Blueprint "Dinero Pro", incluyendo textos,
        gráficos, diseños y marca, es propiedad exclusiva de Dinero Pro y está
        protegido por las leyes de propiedad intelectual aplicables.
      </p>

      <h3 className="text-white font-bold text-base mt-4" data-id="element-83">8. Modificaciones</h3>
      <p data-id="element-84">
        Nos reservamos el derecho de modificar estos términos en cualquier
        momento. Los cambios serán efectivos inmediatamente después de su
        publicación en este sitio.
      </p>
    </>;
}
export function Footer() {
  const [activeModal, setActiveModal] = useState<'privacy' | 'terms' | null>(null);
  return <>
      <footer className="py-8 text-center text-sm border-t border-white/5 mt-20" data-id="element-85">
        <p className="text-gray-600" data-id="element-86">
          © 2026 Dinero Pro. Todos los derechos reservados.
        </p>
        <p className="mt-2 text-gray-600" data-id="element-87">
          Este sitio no es parte de Facebook ni de Meta Inc.
        </p>
        <div className="mt-4 flex items-center justify-center gap-4" data-id="element-88">
          <button onClick={() => setActiveModal('privacy')} className="text-gray-500 hover:text-[#39FF14] transition-colors duration-200 underline underline-offset-2" data-id="element-89">
            Política de Privacidad
          </button>
          <span className="text-gray-700" data-id="element-90">|</span>
          <button onClick={() => setActiveModal('terms')} className="text-gray-500 hover:text-[#39FF14] transition-colors duration-200 underline underline-offset-2" data-id="element-91">
            Términos y Condiciones
          </button>
        </div>
      </footer>

      <LegalModal isOpen={activeModal === 'privacy'} onClose={() => setActiveModal(null)} title="Política de Privacidad" data-id="element-92">
        <PrivacyContent data-id="element-93" />
      </LegalModal>

      <LegalModal isOpen={activeModal === 'terms'} onClose={() => setActiveModal(null)} title="Términos y Condiciones" data-id="element-94">
        <TermsContent data-id="element-95" />
      </LegalModal>
    </>;
}